export const postToParent = (source, payload) =>  window.parent.postMessage({ source, payload }, window.location.origin);

export const isTopLevelWindow = () => window === window.top;

export const inIframeNow = () => window !== window.parent;
